// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/megaphone.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/megaphone'

import { Icon, type IconComponentProps } from '../icon'

export const MegaphoneIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
